import { orderService } from "../_services";
import { router } from "../_helpers";

const initialState = () => ({
  earnings: {
    dataLastMonths: {
      keys: [],
      values: []
    },
    dataChosenMonthYear: {
      count: 0,
      costsPrepay: 0,
      costsPostpay: 0,
      earningsPrepay: 0,
      earningsPostpay: 0
    }
  },
  orders: []
});

const state = initialState();

const actions = {
  getEarnings({ commit, dispatch }, { month, year }) {
    return orderService
      .getEarnings(month, year)
      .then(earnings => {
        commit("updateEarnings", earnings.earnings);
      })
      .catch(err => {
        dispatch("user/clearLoginData", null, { root: true });
        dispatch(
          "alert/alert",
          {
            title: "Wystąpił błąd!",
            message: `${
              err.error
            }  Prosimy o wylogowanie się z panelu na hurtowni eromed.pl`
          },
          { root: true }
        );
        router.push("/login");
      });
  },

  getOrders({ dispatch, commit }, { from, to }) {
    return orderService
      .getOrders(from, to)
      .then(orders => {
        commit("updateOrders", orders);
      })
      .catch(err => {
        dispatch("user/clearLoginData", null, { root: true });
        dispatch(
          "alert/alert",
          {
            title: "Wystąpił błąd!",
            message: `${
              err.error
            }  Prosimy o wylogowanie się z panelu na hurtowni eromed.pl`
          },
          { root: true }
        );
        router.push("/login");
      });
  },

  placeOrder({ dispatch }, { address, cart }) {
    orderService
      .makeOrder(address, cart)
      .then(order => {
        dispatch(
          "alert/alert",
          {
            title: "Zamówienie złożone!",
            message: `ID złożonego zamówienia: ${order.id}`,
            redirPage: "history"
          },
          { root: true }
        );
      })
      .catch(err => {
        dispatch("user/clearLoginData", null, { root: true });
        dispatch(
          "alert/alert",
          {
            title: "Wystąpił błąd!",
            message: `${
              err.error
            }  Prosimy o wylogowanie się z panelu na hurtowni eromed.pl`
          },
          { root: true }
        );
        router.push("/login");
      });
  }
};

const mutations = {
  reset(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  updateOrders(state, orders) {
    state.orders = orders;
  },
  updateEarnings(state, earnings) {
    state.earnings.dataLastMonths.keys = Object.keys(earnings.dataLastMonths);
    state.earnings.dataLastMonths.values = Object.values(
      earnings.dataLastMonths
    );
    state.earnings.dataChosenMonthYear.count =
      earnings.dataChosenMonthYear.count;
    state.earnings.dataChosenMonthYear.costsPostpay =
      earnings.dataChosenMonthYear.costsPostpay;
    state.earnings.dataChosenMonthYear.costsPrepay =
      earnings.dataChosenMonthYear.costsPrepay;
    state.earnings.dataChosenMonthYear.earningsPostpay =
      earnings.dataChosenMonthYear.earningsPostpay;
    state.earnings.dataChosenMonthYear.earningsPrepay =
      earnings.dataChosenMonthYear.earningsPrepay;
    state.earnings.loaded = true;
    state.earnings.loadedTimestamp = +new Date();
  }
};

const getters = {
  earnings(state) {
    return state.earnings;
  }
};

export const order = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
